import axios from 'axios'
import interceptorsSetup from '@/helpers/interceptors'

const baseURL = process.env.VUE_APP_API_URL_V3 + '/accident'

const accidentAPI = axios.create({
  baseURL
})

interceptorsSetup(accidentAPI)

export default class Accident {
  static async getTable (accidentQuery) {
    const result = await accidentAPI.get('/' + accidentQuery.siteId, {
      params:
      {
        start: accidentQuery.start,
        end: accidentQuery.end
      }
    })
    return result.data
  }
  static async createAccident (accident) {
    const result = await accidentAPI.post('/', accident)
    return result.data
  }
  static async updateAccident (accident) {
    const result = await accidentAPI.post('/update', accident)
    return result.data
  }
  static async archiveAccident (accident) {
    const result = await accidentAPI.put('/archive/' + accident)
    return result.data
  }
}
